import { SvgIcon } from '@material-ui/core'

export default function ForwardIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M2.55394 16.0612C2.4578 16.2511 2.49237 16.481 2.6401 16.6341C2.78782 16.7873 3.01632 16.8302 3.20954 16.7411L5.70888 15.5875C7.80948 14.618 10.1018 14.1745 12.3902 14.2788C12.4174 15.0137 12.4577 15.7482 12.5112 16.482L12.5797 17.4209C12.6212 17.9906 13.2564 18.309 13.7376 18.0015C15.8266 16.6666 17.6427 14.9467 19.089 12.9333L19.5492 12.2927C19.6744 12.1184 19.6744 11.8836 19.5492 11.7092L19.089 11.0686C17.6427 9.05523 15.8266 7.33528 13.7376 6.00045C13.2564 5.69292 12.6212 6.01136 12.5797 6.581L12.5112 7.51996C12.4653 8.14982 12.4291 8.78021 12.4025 9.4109H11.7595C8.17848 9.41089 4.90176 11.4245 3.28406 14.6193L2.55394 16.0612Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
